import { render } from "./personal_info.vue?vue&type=template&id=35e265b3"
import script from "./personal_info.vue?vue&type=script&lang=js"
export * from "./personal_info.vue?vue&type=script&lang=js"
script.render = render

export default script